<template>
<tbody id="timestamps" class="table">
  <tr
    v-for="ts in customTimestamps"
  >
    <td>
      {{ ts.label }}
    </td>
    <td>
      {{ formatTs(ts.timestamp) }}
    </td>
  </tr>

  <tr v-if="this.$parent.created_at">
    <td>
      Created At
    </td>
    <td>
      {{ formatTs(this.$parent.created_at) }}
    </td>
  </tr>
  </tr>
  <tr v-if="this.$parent.updated_at">
    <td>
      Updated At
    </td>
    <td>
      {{ formatTs(this.$parent.updated_at) }}
    </td>
  </tr>
</tbody>
</template>

<script>
/*
  Outputs default created_at, updated_at parent values.

  Additional datetime values can be inserted via the `timestamps` array:
    - label: timestamp label
    - value: timestamp value
*/
export default {
  props: {
    customTimestamps: {
      type: Array
    }
  },

  methods: {
    formatTs (ts) {
      return this.$root.displayDateTimeFmt(ts)
    }
  }
}
</script>

<style scoped>
  tbody {
    border-top: 0 !important
  }
</style>



// WEBPACK FOOTER //
// src/components/TimestampRows.vue